<template>
  <div
    class="flex items-start gap-1.5 sm:gap-2 transition-opacity duration-200"
    :class="[disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer']"
    @click="select"
  >
    <div
      class="w-[16px] h-[16px] rounded-full flex items-center justify-center transition-all duration-200 mt-0.5 flex-shrink-0"
      :class="
        isSelected
          ? 'bg-[#d0a444] border border-[#d0a444]'
          : 'bg-white border border-gray-300 hover:border-[#d0a444]'
      "
    >
      <div v-if="isSelected" class="w-1.5 h-1.5 bg-white rounded-full" />
    </div>
    <div v-if="$slots.default" class="flex-1 select-none">
      <slot />
    </div>
    <label
      v-else-if="label"
      class="text-md font-medium text-gray-900 select-none flex-1"
    >
      {{ label }}
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  modelValue?: any;
  value: any;
  label?: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const emit = defineEmits<{
  "update:modelValue": [value: any];
  change: [value: any];
}>();

const isSelected = computed(() => props.modelValue === props.value);

const select = () => {
  if (props.disabled) return;
  emit("update:modelValue", props.value);
  emit("change", props.value);
};
</script>
